import { create } from 'zustand';

export interface PrescriptionLayoutStore {
  scrollTop: number;
  setScrollTop: (value: number) => void;
}

export const usePrescriptionLayoutStore = create<PrescriptionLayoutStore>()((set, get) => ({
  scrollTop: 0,
  setScrollTop: (value: number) => {
    set((prev) => {
      return {
        ...prev,
        scrollTop: value,
      };
    });
  },
}));
